"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationsPlatform = void 0;
// TODO move the translations platform to other repos. This needs to be generic repo.
var TranslationsPlatform;
(function (TranslationsPlatform) {
    // PRIVATE
    TranslationsPlatform["ACCOUNTS"] = "ACCOUNTS_WEB";
    TranslationsPlatform["CARDS"] = "CARDS_WEB";
    TranslationsPlatform["CONFIG"] = "CONFIG";
    TranslationsPlatform["CROSS_COMPONENTS"] = "CROSS_COMPONENTS";
    TranslationsPlatform["DEPOSITS"] = "DEPOSITS_WEB";
    TranslationsPlatform["GLOBAL_POSITION"] = "GLOBAL_POSITION_WEB";
    TranslationsPlatform["LOANS"] = "LOANS_WEB";
    TranslationsPlatform["LOGIN"] = "LOGIN_WEB";
    TranslationsPlatform["NOTIFICATIONS"] = "NOTIFICATIONS_WEB";
    TranslationsPlatform["ONBOARDING"] = "ONBOARDING_WEB";
    TranslationsPlatform["PAYMENTS"] = "PAYMENTS_WEB";
    TranslationsPlatform["PROFILE"] = "PROFILE_WEB";
    TranslationsPlatform["SECURITY"] = "SECURITY_WEB";
    TranslationsPlatform["TRANSFERS"] = "TRANSFERS_WEB";
    TranslationsPlatform["LOYALTY"] = "LOYALTY_WEB";
    TranslationsPlatform["WEB"] = "WEB";
    TranslationsPlatform["CONTACT_SUPPORT"] = "CONTACT_SUPPORT_WEB";
    // CONTACT CENTER
    TranslationsPlatform["ACCOUNTS_CC"] = "ACCOUNTS_CC";
    TranslationsPlatform["CARDS_CC"] = "CARDS_CC";
    TranslationsPlatform["CONFIG_CC"] = "CONFIG_CC";
    TranslationsPlatform["DEPOSITS_CC"] = "DEPOSITS_CC";
    TranslationsPlatform["GLOBAL_POSITION_CC"] = "GLOBAL_POSITION_CC";
    TranslationsPlatform["LOANS_CC"] = "LOANS_CC";
    TranslationsPlatform["LOGIN_CC"] = "LOGIN_WEB_CC";
    TranslationsPlatform["NOTIFICATIONS_CC"] = "NOTIFICATIONS_CC";
    TranslationsPlatform["PAYMENTS_CC"] = "PAYMENTS_CC";
    TranslationsPlatform["PROFILE_CC"] = "PROFILE_CC";
    TranslationsPlatform["SECURITY_CC"] = "SECURITY_CC";
    TranslationsPlatform["TRANSFERS_CC"] = "TRANSFERS_CC";
    TranslationsPlatform["WEB_CC"] = "WEB_CC";
    // BACKOFFICE
    TranslationsPlatform["BACKOFFICE_CC"] = "BACKOFFICE_CC";
    TranslationsPlatform["BO_ASSETS_CC"] = "BO_ASSETS_CC";
    TranslationsPlatform["BO_CAMPAIGNS_CC"] = "BO_CAMPAIGNS_CC";
    TranslationsPlatform["BO_COMUNICATION_MANAGER_CC"] = "BO_COMUNICATION_MANAGER_CC";
    TranslationsPlatform["BO_COLLECTIONS_RECOVERIES"] = "BO_COLLECTIONS_RECOVERIES_CC";
    TranslationsPlatform["BO_CONSENTS_CC"] = "BO_CONSENTS_CC";
    TranslationsPlatform["BO_DMS_CC"] = "BO_DMS_CC";
    TranslationsPlatform["BO_EMBARGOS_CC"] = "BO_EMBARGOS_CC";
    TranslationsPlatform["BO_FEATUREFLAG_CC"] = "BO_FEATUREFLAG_CC";
    TranslationsPlatform["BO_POEDITOR_CC"] = "BO_POEDITOR_CC";
    TranslationsPlatform["BO_QUEUE_MANAGER_CC"] = "BO_QUEUE_MANAGER_CC";
    TranslationsPlatform["BO_SEC_UTILS_CC"] = "BO_SEC_UTILS_CC";
    TranslationsPlatform["BO_SSS_CC"] = "BO_SSS_CC";
    TranslationsPlatform["BO_SSS_LIMITS_CC"] = "BO_SSS_LIMITS_CC";
    TranslationsPlatform["BO_QUICKACTIONS_CC"] = "BO_QUICKACTIONS_CC";
    TranslationsPlatform["BO_OPENEDITOR_CC"] = "BO_OPENEDITOR_CC";
    TranslationsPlatform["BO_FILESMANAGER_CC"] = "BO_FILESMANAGER_CC";
    // WEALTH
    TranslationsPlatform["WEALTH_WEB"] = "WEALTH_WEB";
    TranslationsPlatform["CRYPTO_WEB"] = "CRYPTO_WEB";
    //ACH
    TranslationsPlatform["PANDORA_WEB"] = "PANDORA_WEB";
    TranslationsPlatform["ST_UK_CARDS_WEB"] = "ST_UK_CARDS_WEB";
    TranslationsPlatform["ST_UK_IDV_WEB"] = "ST_UK_IDV_WEB";
    TranslationsPlatform["ST_UK_ALERTS_BLOCKS_WEB"] = "ST_UK_ALERTS_BLOCKS_WEB";
    TranslationsPlatform["ST_UK_PROFILE_WEB"] = "ST_UK_PROFILE_WEB";
    TranslationsPlatform["ST_UK_TRANSFERS_WEB"] = "ST_UK_TRANSFERS_WEB";
})(TranslationsPlatform || (exports.TranslationsPlatform = TranslationsPlatform = {}));
//# sourceMappingURL=types.js.map